module.exports = __webpack_public_path__ + "img/a.70b635f2.jpg";